import React from "react";

interface ResultViewProps {
  failedCount: number;
  faceCapture: string | null;
  playbackUrl: string | null;
}

/** Final outcome of the test with the scanned face and the audio recording */
const ResultView: React.FC<ResultViewProps> = ({ failedCount, faceCapture, playbackUrl }) => (
  <div className="flex flex-col sm:flex-row items-center sm:items-start justify-center gap-5">
    {faceCapture && (
      <div className="shrink-0 text-center">
        <img
          src={faceCapture}
          alt="Scanned face"
          className="w-[180px] h-[180px] object-cover rounded-xl"
        />
        <p className="text-xs text-gray-500 mt-1.5">Your scanned face capture</p>
      </div>
    )}

    <div className="min-w-0 max-w-md text-center sm:text-left">
      <div className="flex items-center justify-center sm:justify-start gap-3 mb-2">
        <div
          className={`w-10 h-10 shrink-0 rounded-full text-white flex items-center justify-center ${failedCount ? "bg-red-500" : "bg-primary"}`}
        >
          <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={3}
              d={failedCount ? "M6 18L18 6M6 6l12 12" : "M5 13l4 4L19 7"}
            />
          </svg>
        </div>
        <h4 className="text-xl font-bold text-gray-900">
          {failedCount ? "Your device is not fully compatible" : "Your device is compatible"}
        </h4>
      </div>
      <p className="text-md text-gray-500">
        {failedCount
          ? `${failedCount} check${failedCount > 1 ? "s" : ""} failed. Fix the issue${failedCount > 1 ? "s" : ""} highlighted in red and retest.`
          : "All checks passed. You can take proctored assessments on this device."}
      </p>

      {playbackUrl && (
        <div className="mt-4">
          <p className="text-sm text-gray-600 mb-1.5">Your audio recording</p>
          <audio src={playbackUrl} controls className="w-full" />
        </div>
      )}
    </div>
  </div>
);

export default ResultView;
